export const FLAG_KEY = 'claude-engineer-2026';

export const FLAG_VARIANT_LOGO = 'logo';
export const FLAG_VARIANT_NO_LOGO = 'no_logo';

export const CLAUDE_ENGINEER_VARIANTS = [FLAG_VARIANT_LOGO, FLAG_VARIANT_NO_LOGO] as const;

export const COURSE_PATH = '/course/ai-engineering-with-claude--nd7426';

export const HOMEPAGE_CTA_ANALYTICS_LABEL = 'claude-engineer-2026 cta clicked';

export const CATALOG_CTA_ANALYTICS_LABEL = 'claude-engineer-2026 cta clicked';

export const EXPERIENCE_CTA_ANALYTICS_LABEL = 'claude_engineer_entry_clicked';

export const CLAUDE_ENGINEER_ASSETS = {
  catalogBannerBg: '/images/experiments/claude-engineer-2026/catalog-banner-bg.jpg',
  claudeLogoCatalog: '/images/experiments/claude-engineer-2026/claude-logo-catalog.svg',
  claudeLogoExperience: '/images/experiments/claude-engineer-2026/claude-logo-experience.svg',
  claudeLogoHero: '/images/experiments/claude-engineer-2026/claude-logo-hero.svg',
  experienceBannerBg: '/images/experiments/claude-engineer-2026/experience-banner-bg.png',
  experienceBannerBgMobile: '/images/experiments/claude-engineer-2026/experience-banner-bg-mobile.jpg',
  heroBg: '/images/experiments/claude-engineer-2026/hero-bg.jpg',
  heroBgMobile: '/images/experiments/claude-engineer-2026/hero-bg-mobile.jpg',
  starIcon: '/images/experiments/claude-engineer-2026/star-icon.svg',
} as const;
